import request from '@/utils/request'

/**
 * 根据问题获取答案
 */
export function getAnswerQuestion (title) {
    return request({
        url: '/v1/portal/question',
        method: 'post',
        data: { title }
    })
}
  
/**
* 获取展示预设问题
*/
export function getPortalQuestion () {
    return request({
        url: '/v1/portal/question',
        method: 'get',
    })
}

/**
* 根据问题id获取答案
*/
export function getPortalQuestionWithId (id) {
    return request({
        url: `/v1/portal/question/${id}`,
        method: 'get',
    })
}